import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCustomizationGroupPartnerItemOptionsQuerySchema } from '~/services/api/generated'

const schema = MenuCustomizationGroupPartnerItemOptionsQuerySchema.strict()

// MenuCustomizationGroupItemOptionsRequest
export const MenuCustomizationGroupPartnerItemOptions = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> => schema
